import cn from 'classnames';
import { FC } from 'react';
import { Link } from 'react-router';

import { BreadcrumbElementType } from '@/shared/config';

import { Icon } from '../Icon/Icon';

import styles from './Breadcrumbs.module.scss';

type DesktopBreadcrumbItemProps = {
  breadcrumb: BreadcrumbElementType;
  index: number;
  isClickable?: boolean;
  isLast?: boolean;
};

export const DesktopBreadcrumbItem: FC<DesktopBreadcrumbItemProps> = (
  props,
) => {
  const { breadcrumb, index, isClickable = true, isLast = false } = props;

  const title =
    typeof breadcrumb.label === 'string' ? breadcrumb.label : undefined;

  if (!breadcrumb.path || !isClickable) {
    return (
      <>
        <p className={cn(styles.labelContainer, 'p1')} title={title}>
          {breadcrumb.label}
        </p>

        {!isLast && (
          <Icon name="arrowDown" className={styles.arrow} size={24} />
        )}
      </>
    );
  }

  return (
    <>
      <Link
        to={breadcrumb.path}
        state={breadcrumb.state}
        className={cn(styles.link, index === 0 && styles.fullName, 'p1')}
        title={title}
      >
        {breadcrumb.label}
      </Link>

      <Icon name="arrowDown" className={styles.arrow} size={24} />
    </>
  );
};
